import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useApi } from 'contexts/Api/Api';
import { useContent } from 'contexts/Content/Content';
import { parseHtml } from 'helpers';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import Image from '../Image/Image';
import LandingAnts from '../LandingAnts/LandingAnts';
import SettingsControls from '../SettingsControls/SettingsControls';
import { Container, Content, ContentGradient } from './Landing.styled';

export default function Landing() {
    const showLandingAnts = process.env.NEXT_PUBLIC_DISABLE_LANDING_ANTS !== '1';
    const api = useApi();
    const content = useContent();
    const router = useRouter();
    const buttonDisabled = useMemo(() => api.authenticate && api.loadingAuthState, [api.authenticate, api.loadingAuthState]);

    function handlePlay() {
        if (api.authenticate && !api.authenticated) {
            api.showAuthModal('login');
            return;
        }
        void router.push('/game');
    }

    return (
        <Container>
            <Content>
                <Box height="100%" position="absolute" right={-250} top={-50} zIndex={3}>
                    <Image alt="Ant Advisor" src="/assets/landing/ant-advisor.png" style={{ width: 450 }} />
                </Box>
                <Box position="relative" zIndex={2}>
                    <Typography
                        color="secondary.light"
                        sx={{ display: 'block', textDecoration: 'uppercase' }}
                        variant="montserrat720"
                    >
                        {content.landing.tagline}
                    </Typography>
                    <Typography
                        component="h1"
                        color="secondary.main"
                        data-testid="landing-title"
                        sx={{ display: 'block', textDecoration: 'uppercase' }}
                        variant="montserrat740"
                    >
                        {content.landing.title}
                    </Typography>
                    <Typography color="secondary.dark" component="h2" sx={{ display: 'block' }} variant="montserrat720">
                        {content.landing.subtitle}
                    </Typography>
                    <Typography
                        dangerouslySetInnerHTML={parseHtml(content.landing.text)}
                        marginY={5}
                        paddingRight={10}
                        paragraph
                        variant="montserrat618"
                    ></Typography>
                    <Button
                        aria-label={content.landing.button}
                        color="secondary"
                        data-testid="landing-cta"
                        disabled={buttonDisabled}
                        size="large"
                        startIcon={buttonDisabled && <CircularProgress color="inherit" size="18px" />}
                        onClick={handlePlay}
                    >
                        {content.landing.button}
                    </Button>
                </Box>
                {showLandingAnts && <LandingAnts />}
                <ContentGradient />
            </Content>
            {process.env.NEXT_PUBLIC_ADMIN && <SettingsControls />}
        </Container>
    );
}
